import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';


import SelectSearchField from '../forms/SelectSearchField';

import StudentAccountPanel from "./widgets/StudentAccountPanel";


export class TimesheetByStudent extends Component {
    static displayName = TimesheetByStudent.name;

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            payWeek: null,
            selectedStudentId: "",
        };

        this.onChangeSelection = this.onChangeSelection.bind(this);
        this.props.store.updateBanner("All Timesheets By Student", false, true);
    }

    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        {this.studentSearch()}
                    </div>
                </div>
                {this.displayTimesheets()}
            </div>
        )
    }

    onChangeSelection(value) {
        this.setState({ selectedStudentId: value })
    }


    studentSearch() {

        let students = this.props.store.students.collection;

        const options = students.map(student => {
            return {
                label: student.name,
                value: student.id
            }
        });


        return (
            <div className="col-12 col-md-6">
                <Formik
                    initialValues={{ accountId: "0" }}
                    onSubmit={(values, { setSubmitting }) => this.onChangeSelection(values, setSubmitting)}
                >
                    <Form>
                        <label for="studentId">Select Student</label>
                        <Field component={SelectSearchField} onChange={(value) => this.onChangeSelection(value) } name="studentId" options={options} isClearable={true} />
                    </Form>
                </Formik>
            </div>
        )
    }


    displayTimesheets() {
        let students = [];
        if (!this.state.selectedStudentId) {
            students = this.props.store.students.collection;

            students = students.filter(student => student.accountIds.length > 0);

            //Sort students by surname. ;
            students = students.sort( (studentA, studentB) => {
                let surnameA = studentA.lastName.toLowerCase();
                let surnameB = studentB.lastName.toLowerCase();

                if (surnameA > surnameB) {
                    return 1;
                }
                else if (surnameA < surnameB) {
                    return -1;
                }
                return 0;
            });
        }
        else {
            students = [this.props.store.students.getById(this.state.selectedStudentId)];
        }
        

        //get all students 
        //filter by react-select filter, if any. 
        //sort students by surname 
        //for each student 
        // Panel <StudentAccountPanel accountIds={student.AccountIds}>
        //  for each account 
        //    subpanel 
        //      Account info 
        //      timesheet table  
        //        signed copy 
        //        start date 
        //        end date 
        //        M - F hours 
        //        Total hours 
        //        Expected balance 

        if (students.length > 0 && students[0] != undefined) {
            return (
                <div>
                    {students.map(student => {
                            return (
                                <div className="card mt-2 studentTimesheetCard">
                                    <div className="card-header d-flex">
                                        <h2 className="h3 mr-auto">{student.name}</h2>
                                        <p className="h3">${student.balance.toFixed(2)}</p>
                                    </div>

                                    <div className="card-body">
                                        <div className="card-title">
                                            <div className="d-flex">
                                                <span className="pl-0 pr-2 pt-2 mr-2 label">
                                                    <strong>TUID: </strong>
                                                    {student.tuid}
                                                </span>
                                                <span className="p-2 mr-2 label">
                                                    <strong>Award Amount: </strong>
                                                    ${student.awardAmount.toFixed(2)}
                                                </span>
                                                <span className="p-2 mr-2 label">
                                                    <strong>Account Balance: </strong>
                                                    ${student.balance.toFixed(2)}
                                                </span>
                                            </div>
                                        </div>

                                        {student.accountIds.length > 0 ?
                                            student.accountIds.map((accountId) => 
                                                <StudentAccountPanel accountId={accountId} store={this.props.store} />
                                            ) :
                                            (
                                                <div className="card-text">
                                                    <h3 class="h5 card-subtitle mb-2">No Account Associated with Student</h3>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
        else {
            return (
                <div className="well">
                    Could not find student.
                </div>
            )
        }
    }
}
